<template>
  <div
    :class="[{ app: data.access_type === 'app' }, 'card', 'video-encoding']"
    :style="data.containerStyle"
  >
    <PopupSpinner :opened="isPopOpend" @popupOff="spinnerOpend" />
    <PopupAlert
      :opened="isAlertOpend"
      :message="alertMessage"
      @popupOff="alertOpend"
    />
    <div class="header">
      <h2 v-text="`3. ${$t('mov_making.video_download')}`"></h2>
    </div>
    <div class="body">
      <p
        class="information"
        v-html="
          $t('mov_making.mov_encoding_desc') +
          '<br>' +
          $t('mov_making.desc_encoding_warning')
        "
      ></p>
      <form action="#">
        <div class="type-box">
          <div>
            <label
              v-html="
                $t('common.t_name_mov', {
                  isInsertEnter: data.access_type === 'app' ? '<br>' : '',
                })
              "
            ></label>
            <span v-text="data.step_info.title"></span>
          </div>
          <div
            :class="{
              'form-box hidden': data.access_type === 'app',
              'form-box': data.access_type === 'web',
            }"
          >
            <label v-text="$t('movie_list.sub_btn_preview')"></label>
            <div class="effect">
              <div class="image-row">
                <div
                  ref="canvasContainer"
                  class="canvas-box"
                  :style="data.imageStyle"
                >
                  <img
                    :src="data.preview_mov"
                    :width="data.width"
                    :height="data.height"
                    class="previewImage"
                    alt="Preview Image"
                  />
                  <img
                    v-show="false"
                    id="targetImg"
                    ref="targetImg"
                    class="preset_image"
                    :width="data.width"
                    :height="data.height"
                  />
                  <canvas
                    id="textCanvas"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                </div>
                <div
                  v-show="data.isMultiCanvas"
                  ref="canvasContainerSecond"
                  class="canvas-box"
                  :style="data.imageStyle"
                >
                  <img
                    :src="data.preview_mov"
                    :width="data.width"
                    :height="data.height"
                    class="previewImage"
                    alt="Preview Image"
                  />
                  <img
                    v-show="false"
                    id="targetImgSecond"
                    ref="targetImgSecond"
                    :width="data.width"
                    :height="data.height"
                    class="preset_image"
                  />
                  <canvas
                    id="textCanvasSecond"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label v-text="$t('play_list.reg_date')"></label>
            <span v-text="data.step_info.reg_date"></span>
          </div>
          <div>
            <label v-text="$t('mov_making.progress_bar')"></label>
            <progress :value="data.production_per" max="100"></progress>
          </div>
        </div>
      </form>
    </div>
    <div class="footer">
      <button
        id="downloadBtn"
        class="button normal"
        @click.prevent="videoDownload()"
        v-text="$t('mov_making.video_download')"
      ></button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import fabric from 'fabric';
import JSZip from 'jszip';
import eve from '@src/commonEvent';
import { API } from '@config/common';
import EventBus from '@utils/bus';
import TextAnimationSetting from '@action/text_animation_setting';
import videoData from '@api/video';
import storeVideo from '@store/video';
import PopupSpinner from '@components/PopupSpinner.vue';
import PopupAlert from '@components/PopupAlert.vue';

const data = {
  access_type: sessionStorage.getItem('access_type'), // 접근 유형 (app, web)
  step_type: '',
  step_info: { title: '' }, // 단계 정보
  file: undefined, // 영상 파일
  mov_title: null, // 영상 이름
  product_type_id: '', // 디바이스 ID
  production_date: null, // 생성 일자
  img_list: {}, // 선택 사진 목록
  text_list: null, // 문구 목록
  img_list_count: 0, // 이미지 개수
  text_list_len: 3, // 문구 최대 개수
  text_list_index: 0, // 문구 play/draw 인덱스
  text_img_index: 0, // 문구 사진 인덱스 (X)
  text_img_list: [], // 문구 사진 목록
  fb: null,
  fbSecond: null,
  fbText: null, // fabric.IText
  fbTextSecondLine: null,
  cloneFirstLine: null,
  cloneSecondLine: null,
  timer: undefined, // 타이머 함수
  duration: 0, // 영상 시간
  currentTime: 0, // 진행 시간
  preview_mov: 'https://picsum.photos/600/200', // 미리보기 사진
  production_per: 0, // 생성 진행률
  product_type_info: {}, // 디바이스 정보
  img_prefix: 'video', // 이미지 고정 이름
  img_ext: 'jpg', // 이미지 확장자,
  isVerticalAnimationCondition: false,
  isBannerCondition: false,
  is_play: false,
  imageStyle: {
    'max-width': '720px',
    'overflow-x': 'auto',
    'overflow-y': 'hidden',
  },
  containerStyle: {},
  stickers: [],
  read_data: undefined,
  image_option: undefined,
  width: 0,
  height: 0,
  rotate: 'H',
};
let removeVisibilityChange;

const CAPTURE_DATA = {
  DEFAULT_FPS: 30,
  TEXT_IMG_SECTION_COUNT: 3,
  MAX_TEXT_IMG_COUNT: 450,
  TEXT_IMG_COUNT_ONE_THIRD: 0,
  MAX_TEXT_LIST_INDEX: 2,
};
const CAPTURE_STATE = {
  INIT: 0,
  WAIT_CANVAS_TO_IMAGE_FINISH: 1,
  START_IMAGE_TO_BLOB: 2,
  WAIT_IMAGE_TO_BLOB_FINISH: 3,
  START_MAKE_ZIP: 4,
};

export default {
  name: 'mov_endcodding',
  head: {
    title: {
      inner: 'Video',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Edit Video Of Smart Solution',
      },
    ],
  },
  props: ['step_type', 'step_info'],
  components: {
    PopupSpinner,
    PopupAlert,
  },
  data() {
    return {
      data,
      isPopOpend: false,
      isAlertOpend: false,
      alertMessage: '',
      access_type: '',
      imgCount: 0,
      blobCount: 0,
      textCaptureState: 0,
      section_idx: 0,
      img_idx: 0,
    };
  },
  created() {
    data.access_type = sessionStorage.getItem('access_type');
    data.product_type_info = videoData.product_type_info;
    data.product_type_id = videoData.data.product_type_id;
    data.step_type = this.step_type;
    data.step_info = this.step_info;
    this.textCaptureState = CAPTURE_STATE.INIT;

    CAPTURE_DATA.MAX_TEXT_IMG_COUNT =
      !this.step_info.isUseText && this.step_info.duration % 1000 === 0
        ? (this.step_info.duration / 1000) * CAPTURE_DATA.DEFAULT_FPS
        : CAPTURE_DATA.MAX_TEXT_IMG_COUNT;
    CAPTURE_DATA.TEXT_IMG_COUNT_ONE_THIRD =
      CAPTURE_DATA.MAX_TEXT_IMG_COUNT / CAPTURE_DATA.TEXT_IMG_SECTION_COUNT;

    const verticalProduct = { columns: 1, rows: 1, rotate: 'V' };
    data.isVerticalAnimationCondition = _.isMatch(
      data.product_type_info,
      verticalProduct,
    );

    this.dataInit();
    this.pageVisibility();
    this.receiveEventInit();

    setTimeout(() => {
      // dataInit()에서 초기화 시 문구 겹침
      data.width = data.product_type_info.h_res;
      data.height = data.product_type_info.v_res;
      data.rotate = data.product_type_info.rotate;

      this.domEventInit();
      this.record();
    });
  },
  destroyed() {
    EventBus.$off('alert-confirm-event');
    EventBus.$off('is-opend');
  },
  methods: {
    dataInit() {
      data.mov_title = data.step_info.title;
      data.production_date = data.step_info.reg_date;
      data.img_list = { ...data.step_info.img_list };
      data.text_list = data.step_info.text_list;
      data.file = data.step_info.file;
      data.product_type_id = data.step_info.product_type_id;
      data.duration = data.step_info.duration;
      data.isBannerCondition = videoData.feature.banner === 'Y';
      data.stickers = data.step_info.stickers;
      data.image_option = data.step_info.image_option;
      data.read_data = data.step_info.read_data;
      data.elementOnTop = data.step_info.elementOnTop;

      const isNotVerticalSlide =
        data.text_list[0].animation_name !== 'slide_bottom' &&
        data.text_list[0].animation_name !== 'slide_top';
      const isNotHorizontalSlide =
        data.text_list[0].animation_name !== 'slide_left' &&
        data.text_list[0].animation_name !== 'slide_right';
      data.isShowTab = data.isVerticalAnimationCondition
        ? isNotVerticalSlide
        : isNotHorizontalSlide;

      const processAccessTypes = {
        web() {
          const width = data.product_type_info.h_res;
          data.containerStyle['min-width'] =
            width < 1000 ? `${width + 140}px` : '850px';
        },
        default() {},
      };
      const accessType = data.access_type === 'web' ? 'web' : 'default';
      processAccessTypes[accessType]();

      /* 이미지 고정 이름 및 확장자 설정 */
      const { step_info: stepInfo } = data;
      data.img_list_count = _.size(data.img_list);
      data.img_prefix = stepInfo.img_prefix
        ? stepInfo.img_prefix
        : data.img_prefix;
      data.img_ext = stepInfo.img_ext ? stepInfo.img_ext : data.img_ext;
    },
    receiveEventInit() {
      EventBus.$on('alert-confirm-event', () => window.location.reload());
      EventBus.$on('is-opend', (res) => {
        this.isPopOpend = false;
        removeVisibilityChange();
        if (res === 'state_encode') {
          document.querySelector('#downloadBtn').style.background = '#009EFF';
          document.querySelector('#downloadBtn').style.color = '#FFFFFF';
        }
      });
    },
    domEventInit() {
      data.fb = TextAnimationSetting.setCanvasSetting('textCanvas', data);
      data.fbText = TextAnimationSetting.setTextSetting();
      data.fbTextSecondLine = TextAnimationSetting.setTextSetting();
      data.fb.add(data.fbText);
      data.fb.add(data.fbTextSecondLine);

      if (data.product_type_info.dup_type === 'D') {
        data.isMultiCanvas = true;

        data.fbSecond = TextAnimationSetting.setCanvasSetting(
          'textCanvasSecond',
          data,
        );
        data.cloneFirstLine = TextAnimationSetting.setTextSetting();
        data.cloneSecondLine = TextAnimationSetting.setTextSetting();
        data.fbSecond.add(data.cloneFirstLine);
        data.fbSecond.add(data.cloneSecondLine);
      }

      if (data.is_play === true && data.text_list_index === 0) {
        document
          .getElementById('targetImg')
          .setAttribute('src', data.read_data);

        for (let i = 0, len = _.size(data.stickers); i < len; i += 1) {
          const reader = new FileReader();
          reader.readAsDataURL(data.stickers[i]);
          const imgElement = document.getElementById('targetImg');
          data.stickers[i] = new fabric.Image(imgElement, data.image_option);
        }
      }

      data.stickers.forEach((sticker) => {
        data.fb.add(sticker);
        if (data.isMultiCanvas) {
          data.fbSecond.add(sticker);
        }
      });

      this.viewPreview();
    },
    pageVisibility() {
      const self = this;
      // Set the name of the "hidden" property and the change event for visibility
      let hidden;
      let visibilityChange;
      if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
      } else if (typeof document.mozHidden !== 'undefined') {
        // Firefox up to v17
        hidden = 'mozHidden';
        visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        // Chrome up to v32, Android up to v4.4, Blackberry up to v10
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
      }

      function handleVisibilityChange() {
        if (document[hidden]) {
          self.stopPlay();
          self.isPopOpend = false;
          self.isAlertOpend = true;
          self.alertMessage = eve.Lang.t('mov_making.msg_encoding_warning');
        }
      }

      // Warn if the browser doesn't support addEventListener or the Page Visibility API
      if (
        typeof document.addEventListener === 'undefined' ||
        typeof document[hidden] === 'undefined'
      ) {
        alert('Requires the latest browser to support Page Visibility APIs.');
      } else {
        // Handle page visibility change
        document.addEventListener(
          visibilityChange,
          handleVisibilityChange,
          false,
        );
        removeVisibilityChange = () => {
          document.removeEventListener(
            visibilityChange,
            handleVisibilityChange,
            false,
          );
        };
        window.onpopstate = () => {
          removeVisibilityChange();
          window.location.reload();
        };
      }
    },
    viewPreview() {
      /* 썸네일 이미지 추출 */
      const previewKey = _.findKey(data.img_list, (img) => !!img);
      data.preview_mov = data.img_list[previewKey];
      _.forEach(document.querySelectorAll('.previewImage'), (img) => {
        img.setAttribute('src', data.img_list[previewKey]);
        img.style.width = data.width;
        img.style.height = data.height;
      });
    },
    imageToBlob() {
      const canvas = document.querySelector('#textCanvas');
      const ctx = canvas.getContext('2d');
      this.blobCount = 0;

      for (let i = 0; i < _.size(data.text_img_list); i += 1) {
        for (let j = 0; j < _.size(data.text_img_list[i]); j += 1) {
          ctx.putImageData(data.text_img_list[i][j], 0, 0);
          canvas.toBlob((blob) => {
            data.text_img_list[i][j] = blob.slice();
            this.blobCount += 1;
          }, 'png');
        }
      }
    },
    captureTimer() {
      if (window.location.pathname !== '/video') {
        return;
      }

      switch (this.textCaptureState) {
        case CAPTURE_STATE.WAIT_CANVAS_TO_IMAGE_FINISH:
          if (this.imgCount >= CAPTURE_DATA.MAX_TEXT_IMG_COUNT) {
            this.textCaptureState = CAPTURE_STATE.START_IMAGE_TO_BLOB;
          }
          break;

        case CAPTURE_STATE.START_IMAGE_TO_BLOB:
          this.imageToBlob();
          this.textCaptureState = CAPTURE_STATE.WAIT_IMAGE_TO_BLOB_FINISH;
          break;

        case CAPTURE_STATE.WAIT_IMAGE_TO_BLOB_FINISH:
          if (this.blobCount >= CAPTURE_DATA.MAX_TEXT_IMG_COUNT) {
            this.textCaptureState = CAPTURE_STATE.START_MAKE_ZIP;
          }
          break;

        case CAPTURE_STATE.START_MAKE_ZIP:
          this.makeZipFile(
            data.step_type,
            data.step_info.product_type_id,
            data.step_info.encode_data,
          );
          // END OF TIMER
          return;

        default:
          break;
      }

      setTimeout(this.captureTimer, 500);
    },
    record() {
      data.text_img_list = [];
      this.imgCount = 0;
      this.blobCount = 0;

      this.play();
      this.spinnerOpend();

      setTimeout(() => {
        this.textCaptureState = CAPTURE_STATE.WAIT_CANVAS_TO_IMAGE_FINISH;
        this.captureTimer();
      }, 500);
    },
    stopPlay() {
      data.currentTime = 0;
      data.text_list_index = 0;
      data.is_play = false;
    },
    saveText() {
      const canvas = document.querySelector('#textCanvas');
      const ctx = canvas.getContext('2d');
      const sectionIdx =
        this.section_idx +
        Math.floor(this.imgCount / CAPTURE_DATA.TEXT_IMG_COUNT_ONE_THIRD);

      if (!data.text_img_list[sectionIdx]) {
        data.text_img_list[sectionIdx] = [];
        this.img_idx = 0;
      }

      const imgData = ctx.getImageData(0, 0, data.width, data.height) || {};
      data.text_img_list[sectionIdx][this.img_idx] = imgData;
      this.img_idx += 1;
    },
    render() {
      this.drawImage();
      if (data.step_info.isUseText) this.drawText();
      this.saveText();

      data.currentTime = Math.round(
        (data.duration / CAPTURE_DATA.MAX_TEXT_IMG_COUNT) * this.imgCount,
      );
      data.production_per = (data.currentTime / data.duration) * 80;
      this.imgCount += 1;

      if (this.imgCount >= CAPTURE_DATA.MAX_TEXT_IMG_COUNT) {
        data.is_play = false;
      }
    },
    limitLoop(fn, fps) {
      let then = new Date().getTime();

      fps = fps || 60;
      const interval = 1000 / fps;

      // eslint-disable-next-line no-unused-vars
      return (function loop(time) {
        if (data.is_play === true) {
          requestAnimationFrame(loop);

          const now = new Date().getTime();
          const delta = now - then;

          if (delta > interval) {
            then = now - (delta % interval);
            fn();
          }
        }
      })(0);
    },
    play() {
      data.is_play = true;
      this.limitLoop(this.render, CAPTURE_DATA.DEFAULT_FPS);
    },
    drawImage() {
      let key = 0 || '';
      let url = '';

      // [A] 이미지 주소 가져오기
      if (data.step_type === 'image') {
        key = `${data.img_prefix}${
          Math.floor(data.currentTime / (data.duration / data.img_list_count)) +
          1
        }.${data.img_ext}`;
        url = data.img_list[key];
      } else {
        key = `${data.img_prefix}${Math.floor(data.currentTime / 100) + 1}.${
          data.img_ext
        }`;
        url = data.img_list[key];
      }

      const imgList = document.querySelectorAll('.previewImage');
      if (!url || !_.size(imgList)) {
        return;
      }
      _.forEach(imgList, (img) => {
        img.setAttribute('src', url);
      });
    },
    drawText() {
      const textInfo = data.text_list[data.text_list_index];
      let diffTime;

      if (!textInfo) {
        return;
      }

      if (
        textInfo.start_sec <= data.currentTime &&
        textInfo.started === false
      ) {
        if (data.isShowTab) {
          diffTime = this.getDiffTime();
          if (data.text_list_index !== CAPTURE_DATA.MAX_TEXT_LIST_INDEX) {
            data.text_list_index += 1;
          }
        } else {
          diffTime = 15000;
        }

        this.executeAnimation(textInfo, diffTime);
        textInfo.started = true;
      }
    },
    getDiffTime() {
      /* 텍스트 애니메이션 지연 시간 가져오기 */
      const len = _.size(data.text_list) - 1;
      let x = 0;
      let y = 0;
      let diffTime = 0;

      if (len !== data.text_list_index) {
        // 마지막 문구가 아닐 경우
        x = data.text_list[data.text_list_index].start_sec;
        y = data.text_list[data.text_list_index + 1].start_sec;
        // [A]
        diffTime = y - x;
      } else {
        // 마지막 문구일 경우
        x = data.currentTime;
        y = data.duration;
        diffTime = y - x;
      }

      return diffTime;
    },
    executeAnimation(textInfo, diffTime) {
      // 영상 크기에 맞추어 폰트 사이즈 변경
      TextAnimationSetting.setFontSize(
        data,
        textInfo,
        textInfo.text_size_type,
        textInfo.text_size_type_second,
      );

      // 1x1 세로인경우 세로 텍스트 출력
      if (this.data.isVerticalAnimationCondition) {
        TextAnimationSetting.verticalAnimationText(
          this.data,
          textInfo,
          textInfo.animation_name,
          diffTime,
        );
      } else {
        TextAnimationSetting.setTextAnimation(
          this.data,
          textInfo,
          textInfo.animation_name,
          diffTime,
        );
      }
    },
    makeZipFile(makeType, productTypeId, encodeData) {
      let makeUrl = '';

      if (makeType === 'theme') {
        makeUrl = API.API_THEME_CONVERT_THEME;
      } else if (makeType === 'image') {
        makeUrl = API.API_IMAGE_CONVERT_IMAGE;
      } else if (makeType === 'upload-effect') {
        makeUrl = API.CONVERT_CUSTOM_TEXT;
      } else {
        makeUrl = API.CONVERT_CUSTOM;
      }

      if (videoData.role_code === '12006') {
        makeUrl += `?user_id=${videoData.user_id}`;
      }

      const zip = new JSZip();

      zip.file('config.json', JSON.stringify(encodeData));
      if (makeType === 'upload' || makeType === 'upload-effect') {
        zip.file(`${encodeData.movie_name}`, data.file);
      }

      if (data.isShowTab) {
        if (data.step_type === 'image') {
          const imgFolder = zip.folder(`jpg`);
          let imgIdx = 0;

          _.forEach(data.img_list, (img) => {
            imgIdx += 1;
            imgFolder.file(`${imgIdx}.jpg`, this.dataURItoBlob(img));
          });

          _.forEach(data.text_img_list, (imgs, idx) => {
            const textImgFolder = zip.folder(`images${idx}`);

            _.forEach(data.text_img_list[idx], (img, idx2) => {
              textImgFolder.file(`${idx2}.png`, img);
            });
          });
        } else {
          _.forEach(data.text_img_list, (imgs, idx) => {
            const textImgFolder = zip.folder(`images${idx}`);

            _.forEach(data.text_img_list[idx], (img, idx2) => {
              textImgFolder.file(`${idx2}.png`, img);
            });
          });
        }
      } else {
        if (data.step_type === 'image') {
          const imgFolder = zip.folder(`jpg`);
          let jpgIdx = 0;

          _.forEach(data.img_list, (img) => {
            jpgIdx += 1;
            imgFolder.file(`${jpgIdx}.jpg`, this.dataURItoBlob(img));
          });
        }

        _.forEach(data.text_img_list, (imgs, idx) => {
          const textImgFolder = zip.folder(`images${idx}`);

          _.forEach(data.text_img_list[idx], (img, idx2) => {
            textImgFolder.file(`${idx2}.png`, img);
          });
        });
      }

      zip
        .generateAsync(
          { type: 'blob', compression: 'STORE' },
          function updateCallback(metadata) {
            data.production_per = 80 + metadata.percent.toFixed(2) * 0.2;
          },
        )
        .then(async (content) => {
          // saveAs(content, new Date().getTime());
          const formData = new FormData();
          formData.append('url', makeUrl);
          formData.append('product_type_id', productTypeId);
          formData.append('file', content);

          if (makeType === 'theme') {
            formData.append('theme_id', encodeData.id);
            formData.append('title', encodeData.movie_name);
          } else if (makeType === 'image') {
            formData.append('title', data.mov_title);
          }

          await this.$store.dispatch('VIDEO_MAKING', formData);
        });
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      let byteString;

      // 정지 영상 제작 시 crop된 이미지 url이 string이 아닌 blob 형태로 넘어오는 경우
      if (typeof dataURI === 'object') {
        // const chunk = dataURI.slice(0, dataURI.size, 'image/png');
        return new Blob([dataURI], { type: 'image/png' });
      }

      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }

      // separate out the mime component
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      const byteSize = _.size(byteString);
      const ia = new Uint8Array(byteSize);
      for (let i = 0; i < byteSize; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    videoDownload() {
      this.spinnerOpend();
      this.$store.dispatch('VIDEO_DOWNLOAD', {
        data: data.mov_title,
        jobId: storeVideo.state.job_id,
      });
    },
    spinnerOpend() {
      this.isPopOpend = !this.isPopOpend;
    },
    alertOpend() {
      this.isAlertOpend = !this.isAlertOpend;
    },
    checkText(text) {
      if (text === undefined) return false;
      if (text === '') return false;
      if (text === ' ') return false;

      return true;
    },
  },
};
</script>

<style scoped lang="scss">
.card.video-encoding {
  max-width: 800px;
  padding: 24px;
  margin: 0 auto;
  background-color: $white;
  position: relative;
  -webkit-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

  &.app {
    margin: 12px 0;
    padding: 20px 15px;
  }

  .header {
    h2 {
      margin: 0;
      font-size: 24px;
    }
  }

  .body {
    margin-top: 20px;
    background-color: $white;

    .information {
      font-size: 12px;
      color: $gray-33;
      line-height: 1.5em;
    }

    label {
      min-width: 80px;
      padding-top: 12px;
      font-size: 14px;
    }

    span {
      font-size: 13px;
    }

    .type-box {
      display: table;
      grid-template-columns: 100px 100px 100px;
      grid-template-rows: 50px 50px;

      > * {
        display: table-row;
      }

      label {
        display: table-cell;
        padding: 12px 10px 12px 0;
      }

      label + * {
        display: table-cell;
      }
    }

    .form-box {
      margin-top: 16px;
      max-width: 1000px;

      label + * {
        margin-left: 12px;
      }

      input,
      .button {
        height: 44px;
      }

      input[type='text'] {
        font-size: 16px;
      }

      .button {
        min-width: 100px;
        max-width: 120px;
        padding: 0;
      }

      .effect {
        max-width: calc(100% - 92px);
        padding: 10px 0px;
        margin: 0px;

        .image-row {
          .canvas-box {
            position: relative;

            img {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
            }
            .background {
              top: 0;
            }
          }
        }
      }
    }
  }

  .footer {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .button {
      width: 125px;
      height: 44px;
    }

    .button + .button {
      margin-left: 12px;
    }
  }
}

@media (max-width: 480px) {
  .card.video-encoding {
    width: 90vw;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  progress {
    width: 130px;
  }
}
@media (min-width: 480px) {
  .card.video-encoding {
    width: 550px;
  }
  progress {
    width: 170px;
  }
  .form-box {
    display: flex;
    align-items: flex-start;
  }
}
</style>
